import toast from '../services/toast';

// Mesma paleta e mesmo layout usados no card "colecionável" da tela de Figurinha
// (ver frontend/src/pages/Figurinha.css, classes .fcard*).
const TIERS = {
  cinza: { cor: '#b7b7cf', cor2: '#7d7da0', glow: 'rgba(183,183,207,0.5)' },
  verde: { cor: '#34D399', cor2: '#1a8f6a', glow: 'rgba(52,211,153,0.55)' },
  azul: { cor: '#6fb3ff', cor2: '#3d7fd6', glow: 'rgba(111,179,255,0.55)' },
  roxo: { cor: '#b79bff', cor2: '#8b5cf6', glow: 'rgba(183,155,255,0.6)' },
  dourado: { cor: '#F2B341', cor2: '#B9791C', glow: 'rgba(242,179,65,0.7)' },
};
const COR_TEXTO = '#EFEAFB';
const COR_TEXTO_DIM = '#9A90C2';
const COR_OURO = '#F2B341';
const COR_SUCESSO = '#34D399';

function roundRectPath(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wrapLines(ctx, texto, maxWidth) {
  const palavras = texto.split(' ');
  const linhas = [];
  let atual = '';
  for (const p of palavras) {
    const teste = atual ? `${atual} ${p}` : p;
    if (ctx.measureText(teste).width > maxWidth && atual) {
      linhas.push(atual);
      atual = p;
    } else {
      atual = teste;
    }
  }
  if (atual) linhas.push(atual);
  return linhas;
}

// Desenha (ou só mede, quando medir=true) o conteúdo do cartão a partir de cardY.
// Retorna o Y final do conteúdo — usado para dimensionar o canvas real.
function montarConteudo(ctx, dados, { medir, cx, cardX, cardW, cardY, tier }) {
  const rowX1 = cardX + 44, rowX2 = cardX + cardW - 44, rowW = cardW - 88;

  function texto(x, y, str, { size = 24, weight = '600', color = COR_TEXTO, align = 'left' } = {}) {
    ctx.font = `${weight} ${size}px Arial, sans-serif`;
    ctx.textAlign = align;
    if (!medir) { ctx.fillStyle = color; ctx.fillText(str, x, y); }
  }

  let y = cardY + 66;

  // Fita do nível
  const ribbonTxt = `🏆  ${dados.nivelNome.toUpperCase()}`;
  ctx.font = '800 20px Arial, sans-serif';
  const ribbonW = ctx.measureText(ribbonTxt).width + 56;
  if (!medir) {
    roundRectPath(ctx, cx - ribbonW / 2, y - 30, ribbonW, 44, 22);
    const rg = ctx.createLinearGradient(cx - ribbonW / 2, 0, cx + ribbonW / 2, 0);
    rg.addColorStop(0, tier.cor); rg.addColorStop(1, tier.cor2);
    ctx.fillStyle = rg;
    ctx.fill();
  }
  texto(cx, y, ribbonTxt, { size: 20, weight: '800', align: 'center', color: '#1a1206' });

  // Medalhão do mascote
  y += 96;
  const raio = 66;
  if (!medir) {
    const anelGrad = ctx.createLinearGradient(cx - raio, y - raio, cx + raio, y + raio);
    anelGrad.addColorStop(0, tier.cor); anelGrad.addColorStop(1, tier.cor2);
    ctx.beginPath(); ctx.arc(cx, y, raio, 0, Math.PI * 2);
    ctx.fillStyle = anelGrad; ctx.fill();
    ctx.beginPath(); ctx.arc(cx, y, raio - 6, 0, Math.PI * 2);
    ctx.fillStyle = '#171335'; ctx.fill();
  }
  ctx.font = '64px Arial, sans-serif';
  ctx.textAlign = 'center';
  if (!medir) { ctx.fillStyle = COR_TEXTO; ctx.fillText(dados.animalEmoji, cx, y + 22); }

  y += raio + 56;
  texto(cx, y, dados.nome, { size: 34, weight: '800', align: 'center', color: COR_TEXTO });

  y += 38;
  texto(cx, y, 'TORCEDOR DO', { size: 15, weight: '700', align: 'center', color: COR_TEXTO_DIM });

  y += 44;
  ctx.font = '800 40px Arial, sans-serif';
  ctx.textAlign = 'center';
  if (!medir) {
    const tg = ctx.createLinearGradient(cx - 150, 0, cx + 150, 0);
    tg.addColorStop(0, '#fff'); tg.addColorStop(1, COR_OURO);
    ctx.fillStyle = tg;
  }
  ctx.fillText(dados.timeNome, cx, y);

  y += 34;
  texto(cx, y, `📍 ${dados.cidadeNome}`, { size: 16, align: 'center', color: COR_TEXTO_DIM });

  // Selo de torcida
  y += 30;
  const badgeH = dados.colocacaoDoTime ? 84 : 62;
  if (!medir) {
    roundRectPath(ctx, rowX1, y, rowW, badgeH, 16);
    ctx.fillStyle = 'rgba(242,179,65,0.08)';
    ctx.fill();
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(242,179,65,0.3)';
    ctx.stroke();
  }
  const torcedoresTxt = `${dados.torcedores.toLocaleString('pt-BR')} torcedor${dados.torcedores === 1 ? '' : 'es'} do ${dados.timeNome}`;
  texto(rowX1 + 22, y + 34, torcedoresTxt, { size: 19, weight: '700', color: COR_TEXTO, align: 'left' });
  if (dados.colocacaoDoTime) {
    texto(rowX1 + 22, y + 64, `👑  ${dados.colocacaoDoTime}ª maior torcida de ${dados.cidadeNome}`, { size: 15, weight: '700', color: COR_OURO, align: 'left' });
  }
  y += badgeH + 24;

  // Craque
  if (dados.jogadorNome) {
    texto(rowX1, y, '⭐  MEU CRAQUE', { size: 13, weight: '700', color: COR_TEXTO_DIM, align: 'left' });
    y += 30;
    texto(rowX1, y, dados.jogadorNome, { size: 22, weight: '800', color: COR_TEXTO, align: 'left' });
    y += 26;
    texto(rowX1, y, dados.jogadorTimeNome, { size: 15, color: COR_TEXTO_DIM, align: 'left' });
    y += 34;
  }

  // Estatísticas
  const statW = (rowW - 20) / 3, statH = 108;
  const stats = [
    ['🎯', String(dados.feitos), 'PALPITES'],
    ['✅', String(dados.acertados), 'ACERTOS'],
    ['🔥', `${dados.aproveitamento.toString().replace('.', ',')}%`, 'PRECISÃO'],
  ];
  stats.forEach(([emoji, valor, label], i) => {
    const sx = rowX1 + i * (statW + 10);
    if (!medir) {
      roundRectPath(ctx, sx, y, statW, statH, 16);
      ctx.fillStyle = 'rgba(255,255,255,0.05)';
      ctx.fill();
    }
    ctx.font = '26px Arial, sans-serif';
    ctx.textAlign = 'center';
    if (!medir) { ctx.fillStyle = COR_TEXTO; ctx.fillText(emoji, sx + statW / 2, y + 38); }
    texto(sx + statW / 2, y + 74, valor, { size: 25, weight: '800', align: 'center', color: COR_TEXTO });
    texto(sx + statW / 2, y + 94, label, { size: 11, weight: '700', align: 'center', color: COR_TEXTO_DIM });
  });
  y += statH + 40;

  // XP
  if (!medir) {
    ctx.strokeStyle = 'rgba(255,255,255,0.1)';
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(rowX1, y - 22); ctx.lineTo(rowX2, y - 22); ctx.stroke();
  }
  texto(rowX1, y, `${dados.xp} XP`, { size: 15, weight: '700', color: COR_TEXTO_DIM, align: 'left' });
  if (dados.temProximoNivel) {
    texto(rowX2, y, `Faltam ${dados.xpFaltam} XP`, { size: 15, weight: '700', color: COR_TEXTO_DIM, align: 'right' });
  }

  y += 22;
  const barW = rowW, barH = 14;
  if (!medir) {
    roundRectPath(ctx, rowX1, y, barW, barH, 8);
    ctx.fillStyle = '#1E1A38';
    ctx.fill();
    const pct = Math.max(0, Math.min(100, dados.xpPercentual || 0)) / 100;
    if (pct > 0) {
      const fillW = Math.max(barH, barW * pct);
      roundRectPath(ctx, rowX1, y, fillW, barH, 8);
      const barGrad = ctx.createLinearGradient(rowX1, 0, rowX1 + barW, 0);
      barGrad.addColorStop(0, COR_SUCESSO); barGrad.addColorStop(1, COR_OURO);
      ctx.fillStyle = barGrad;
      ctx.fill();
      ctx.save();
      ctx.shadowColor = COR_OURO;
      ctx.shadowBlur = 12;
      ctx.beginPath();
      ctx.arc(rowX1 + fillW, y + barH / 2, 6, 0, Math.PI * 2);
      ctx.fillStyle = '#fff';
      ctx.fill();
      ctx.restore();
    }
  }
  y += barH + 26;

  if (dados.temProximoNivel && dados.nivelProximoNome) {
    texto(rowX1, y, `Próximo nível: ${dados.nivelProximoNome}`, { size: 14, color: COR_TEXTO_DIM, align: 'left' });
    y += 30;
  }

  // Rodapé
  y += 12;
  texto(cx, y, '⚡  Orgulho do Futebol Regional', { size: 14, weight: '700', align: 'center', color: COR_TEXTO_DIM });
  y += 26;
  texto(cx, y, 'palpitar', { size: 20, weight: '800', align: 'center', color: COR_OURO });
  y += 30;

  return y;
}

export async function gerarImagemFigurinha(dados) {
  const W = 800;
  const tier = TIERS[dados.nivelCor] || TIERS.cinza;
  const pad = 30;
  const cardX = pad, cardW = W - pad * 2, cardY = pad, cx = W / 2;

  // Passo 1: mede a altura do conteúdo num contexto descartável.
  const medida = document.createElement('canvas');
  medida.width = W; medida.height = 100;
  const ctxMedida = medida.getContext('2d');
  const contentBottom = montarConteudo(ctxMedida, dados, { medir: true, cx, cardX, cardW, cardY, tier });
  const cardH = contentBottom - cardY + 30;
  const H = cardH + pad * 2;

  // Passo 2: desenha de verdade num canvas do tamanho certo.
  const canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d');

  const fundo = ctx.createLinearGradient(0, 0, 0, H);
  fundo.addColorStop(0, '#151228'); fundo.addColorStop(1, '#0A0913');
  ctx.fillStyle = fundo;
  ctx.fillRect(0, 0, W, H);

  const radius = 40;
  const cardGrad = ctx.createLinearGradient(cardX, cardY, cardX, cardY + cardH);
  cardGrad.addColorStop(0, '#221c40'); cardGrad.addColorStop(1, '#120f22');
  roundRectPath(ctx, cardX, cardY, cardW, cardH, radius);
  ctx.fillStyle = cardGrad;
  ctx.fill();

  // Clima de estádio: brilho de refletor + arco de campo + partículas — tudo sutil, clipado ao cartão.
  ctx.save();
  roundRectPath(ctx, cardX, cardY, cardW, cardH, radius);
  ctx.clip();

  const glow = ctx.createRadialGradient(cx, cardY + 40, 10, cx, cardY + 40, cardW * 0.9);
  glow.addColorStop(0, tier.glow.replace(/[\d.]+\)$/, '0.16)'));
  glow.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(cardX, cardY, cardW, cardH);

  ctx.strokeStyle = 'rgba(255,255,255,0.05)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(cx, cardY + cardH + 120, 170, 0, Math.PI * 2);
  ctx.stroke();

  if (dados.nivelCor === 'dourado') {
    ctx.save();
    ctx.translate(cx, cardY + 190);
    ctx.globalAlpha = 0.08;
    for (let i = 0; i < 16; i++) {
      ctx.rotate((Math.PI * 2) / 16);
      ctx.fillStyle = COR_OURO;
      ctx.fillRect(-3, -150, 6, 60);
    }
    ctx.restore();
  }

  const sparks = [[0.14, 0.16], [0.86, 0.34], [0.16, 0.58]];
  sparks.forEach(([fx, fy]) => {
    const sx = cardX + cardW * fx, sy = cardY + cardH * fy;
    ctx.beginPath();
    ctx.arc(sx, sy, 3, 0, Math.PI * 2);
    ctx.fillStyle = tier.cor;
    ctx.shadowColor = tier.cor;
    ctx.shadowBlur = 8;
    ctx.fill();
    ctx.shadowBlur = 0;
  });
  ctx.restore();

  ctx.lineWidth = 3;
  ctx.strokeStyle = tier.cor;
  roundRectPath(ctx, cardX, cardY, cardW, cardH, radius);
  ctx.stroke();

  montarConteudo(ctx, dados, { medir: false, cx, cardX, cardW, cardY, tier });

  return new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
}

export async function compartilharFigurinha(dados) {
  const blob = await gerarImagemFigurinha(dados);
  if (!blob) return false;
  const file = new File([blob], 'figurinha-palpitar.png', { type: 'image/png' });

  const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.damelsoft.com.br';
  const texto = `🏆 Já criou sua Figurinha de Torcedor?\n\nMostre sua paixão pelo seu time, evolua seu nível de torcedor e participe dos rankings.\n\nCrie agora a sua gratuitamente:\n${APP_URL}`;

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], text: texto });
      return true;
    } catch (_) {
      return false;
    }
  }

  // A maioria dos navegadores desktop não suporta compartilhar arquivo — o
  // melhor disponível aqui é baixar a imagem e já deixar a mensagem de
  // incentivo copiada, pra colar junto onde a pessoa for compartilhar
  // (mesma estratégia de fallback de services/share.js).
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'figurinha-palpitar.png';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  try {
    await navigator.clipboard.writeText(texto);
    toast.success('Imagem baixada e texto copiado! Cole a mensagem junto da imagem.');
  } catch (_) {
    // Sem acesso à área de transferência — a imagem já foi baixada normalmente.
  }
  return true;
}
